import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import ColumnH1 from '../atoms/columnH1'
import Introduction004 from './Introduction004'
import Introduction005 from './Introduction005'
import Introduction006 from './Introduction006'
import Introduction007 from './Introduction007'
import Introduction008 from './Introduction008'
import Introduction009 from './Introduction009'
import Introduction010 from './Introduction010'
import Introduction011 from './Introduction011'
import Introduction012 from './Introduction012'

const Wrapper = styled.article`
  position: relative;
  margin-bottom: 30px;

  .p-txt-date {
    margin-top: -10px;
    color: #ababab;
  }

  section {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 16px;
    color: #505050;
    line-height: 1.6em;

    h1 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #f5f5f5;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-bottom: 30px;
      margin-top: 10px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #77d7c9;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h2 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #ffffff;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-top: 10px;
      margin-bottom: 30px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #d8d8d8;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h3 {
      color: #414141;
      font-size: 16px;
      line-height: 1.4em;
      background: #ffffff;
      width: auto;
      padding: 10px 0 8px;
      margin-top: -10px;
      margin-bottom: 20px;
      border-top: solid 2px #e5e5e5;
      border-bottom: solid 2px #e5e5e5;
    }

    p {
      padding-bottom: 30px;
      line-height: 2;
      position: relative;

      span {
        background: linear-gradient(transparent 60%, #ff6 60%);
        font-weight: 600;
      }

      .p-list-link {
        position: absolute;
        top: 6px;
        right: 2px;

        &:before {
          display: block;
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          top: 7px;
          left: -14px;
          border-left: 8px solid #3ec7b3;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
        }
      }

      &.txt-color-red {
        color: #ff6969;
      }
    }

    .link-div {
      width: 100%;
      display: flex;
      justify-content: left;
      padding-bottom: 30px;

      > div {
        width: 50px;
      }

      .link-p {
        width: calc(100% - 50px);

        .p-list-link {
          position: absolute;
          top: -3px;
          left: 30px;

          &:before {
            display: block;
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            top: 11px;
            left: -14px;
            border-left: 8px solid #3ec7b3;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
          }
        }
      }
    }

    img {
      width: 100%;
      height: auto;
      padding-bottom: 30px;
    }
  }

  ${BreakPoints.large} {
  }
`
type Props = {
  /** 広告の番号 */
  no: number
}

/**
 * コラム記事詳細：記事本体
 * @constructor
 */
const ColumnDetailInner0083 = (props: Props): JSX.Element => (
  <Wrapper>
    <ColumnH1 label="みなし残業が違法になる？そんなケースとは" />
    {/** TODO 川上申し送り事項：▼投稿日をここに表示 */}
    <p className="p-txt-date">2025.08.25</p>
    <section>
      {/** TODO 川上申し送り事項：▼記事投稿（？）で作成された内容がここに入る予定 */}
      <p>
        みなし残業は過去の労働判例において違法と判断されたケースは少なくありません。良かれと思って導入していた制度が「違法」となってしまうと、その爪痕は大きく、労使間でも大きなしこりを残すこととなります。今回はみなし残業の制度的な解説、違法になるケースやその対策、さらに違法時の請求について詳しく解説します。
      </p>
      <img src="/images/column/details/c0083.jpg" alt="キンクラコラム画像83" />
      <div id="toc1">
        <h1>みなし残業制度とは</h1>
      </div>
      <p>
        まず、残業手当とは、原則として、法定労働時間（1日8時間・週40時間）を超えた労働に対して本来支給すべき賃金に割増率を乗じて支給するものです。他方、みなし残業制度とは
        <span>
          労使合意によって予め設定された時間を残業時間とみなし、固定的に残業代を支給する制度
        </span>
        です。注意点として、例えばみなし残業時間を20時間と設定した場合で25時間の残業があれば、「追加」で5時間分の残業手当を支給しなければなりません。この部分だけを読むと企業側にとっては全くメリットがないのではと考えられます。しかし、毎月固定的に20時間分の残業手当が支給されるのであれば、より生産的な働き方をして「早く帰社しても」20時間分の手当を受けた方が労働者としては得をするということになります。そうなることで、有能な労働者の帰属意識の向上に繋がることや、
        <span>
          長時間労働による過労死に対して歯止めをかけられるというメリット
        </span>
        があります。また、給与計算担当者としても前述のケースであれば20時間以内の残業については支給額に変動がないことから給与計算担当者の負担も少なくなります。
      </p>

      <div id="toc2">
        <h1>みなし残業が違法になるケース</h1>
      </div>
      <p>
        まずは残業時間がみなし時間を超えているにも関わらず追加で残業手当を支給しておらず、かつ、計算した結果、不足額が生じているケースです。前述のケースであれば、あくまで20時間分を固定的に支払っているに過ぎず、それを超える残業があれば当然追加で残業代を支給しなければなりません。
        <br />
        <br />
        また、みなし時間が100時間を超える等、
        <span>
          公序良俗に反し是認できないような時間数となれば違法と判断される可能性が高い
        </span>
        です。そもそも36協定の時間数を大幅に超えるような時間数を設定することも一般的には理解し難く、違法と判断されるケースがあります。
        <br />
        <br />
        他のケースとして、
        <span>
          みなし残業手当を除いた基本給の額が最低賃金を下回っているケース
        </span>
        です。最低賃金は都道府県ごとに定められており、毎年10月頃に改定が行われ、特に近年は上昇傾向が続いており、かつ当該上昇幅も大きくなっています。これはみなし時間を増やすことで結果的に最低賃金を下回っていたというケースもあり、故意ではなくても違法となります。
      </p>

      {/** ここに9パターンの広告設定する */}
      {props.no === 0 && <Introduction004 />}
      {props.no === 1 && <Introduction005 />}
      {props.no === 2 && <Introduction006 />}
      {props.no === 3 && <Introduction007 />}
      {props.no === 4 && <Introduction008 />}
      {props.no === 5 && <Introduction009 />}
      {props.no === 6 && <Introduction010 />}
      {props.no === 7 && <Introduction011 />}
      {props.no === 8 && <Introduction012 />}

      <div id="toc3">
        <h1>違法とならないための対処法</h1>
      </div>
      <p>
        まず、「追加」で残業代を払うべき部分については勤怠によって確認が必要です。みなし時間を超えて残業がある場合は、みなし残業代とは別に残業代を支払わなければなりません。ただし、打刻時間イコール労働時間というわけではありませんので残業時間については一例として、事前承認制等を採用し、その月の残業時間が何時間発生しているのかを明確にしなければ正確な計算ができません。もちろん、打刻時間イコール労働時間と整理している企業もありますが、いずれにせよ、みなし時間を超えた残業に対しては追加の支払いが必要となります。そのための対処法としては、
        <span>
          設定されているみなし時間を超えた労働が確認できた段階で勤怠システムにワーニング表示をすること
        </span>
        が一案です。そうすることで給与計算担当者がみなし時間を超えている分に対して追加の残業代を計算することが可能となります。
      </p>

      <div id="toc4">
        <h1>違法の場合の請求</h1>
      </div>
      <p>
        2020年4月に民法が改正されたことに伴い労働基準法も改正が行われています。残業代の論点に限定すると、残業代請求の時効が2年から（当分の間）3年に延長されています（原則は5年ですが執筆時点では経過措置により3年）。もちろん、残業代は強行法規である労働基準法に規定されていることから、未払があった際には理論上、時効消滅していない分は請求対象となります。すなわち、法改正後の方が請求対象となる期間が延びているため、経営問題にも発展するということです。これは、月々の正確な給与計算が重要な意味を持つということです。
        <br />
        <br />
        また、時代の流れとして、本人だけでなく、代理人弁護士から請求されるという事案も増えています。もちろん、本人か代理人弁護士かで対応方法を変える必要はなく、事実に基づいて粛々と処理をすべきですが、1人の未払が発生した場合、他の従業員は間違っていないという確証は取れず、他の従業員自身が疑心暗鬼となり、立て続けに対応に追われるということが想定されます。
      </p>

      <div id="toc5">
        <h1>最後に</h1>
      </div>
      <p>
        みなし残業の注意点は設定すべき時間数、みなし時間を超えた場合の追加支給の2点が非常に重要な意味を持ちます。法律上「みなし残業」という条文は存在しませんが、契約上の1形態として多くの企業で採用されています。上記の注意点の特に2点目については定期的に見直しを行っていくことで違法状態を回避でき、ひいてはよりよい労使関係に寄与することができます。
      </p>
    </section>
  </Wrapper>
)

export default ColumnDetailInner0083
